module.exports = __webpack_public_path__ + "static/media/ice20.9a759dee.webp";